import React  from 'react';

export function convertToFarsiNumber(number) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    if (number)
        return number
            .toString()
            .replace(/\d/g, x => farsiDigits[x]);
}

export function convertToEnglishNumber(number) {
    if (number !== null)
        return number
            .toString()
            .replace('۰', "0")
            .replace('۱', "1")
            .replace('۲', "2")
            .replace('۳', "3")
            .replace('۴', "4")
            .replace('۵', "5")
            .replace('۶', "6")
            .replace('۷', "7")
            .replace('۸', "8")
            .replace('۹', "9")
    else
        return ""
}

export function convertCurrencyFormatPositiveNegative(num) {
    if (num) {
        const isNegative = num.toString().search("-")

        let formattedNumber = ""
        if (num.toString() !== "-") {
            num = num.toString().replaceAll("-", "")
            formattedNumber = parseFloat(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        } else if (num.length === 1 && num.toString() === "-")
            return "-"
        else
            return 0

        if (isNegative === 0)
            return `-${formattedNumber}`
        else
            return formattedNumber
    }
    return "0"
}

export function convertCurrencyFormat(num) {
    if (num) {
        if (parseInt(num) > 0) {
            return parseFloat(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        } else
            return 0
    }
}

export function convertToMobileNumber(number) {
    let output = "";
    number = convertToEnglishNumber(number)
    if (number !== null)
        number.replace(/^\D*(\d{0,4})\D*(\d{0,3})\D*(\d{0,4})/, function (match, g1, g2, g3) {
                if (g1.length) {
                    output += g1;
                    if (g1.length === 4) {
                        if (g2.length) {
                            output += " " + g2;
                            if (g2.length === 3) {

                                if (g3.length) {
                                    output += " " + g3;
                                }
                            }
                        }
                    }
                }
            }
        );
    /*const strings = output.split(" ");
    let newPhoneNumber = ""
    for (const string of strings) {
        newPhoneNumber = string + " " + newPhoneNumber
    }
    return newPhoneNumber;*/

    return output;
}

export function convertNumberReverse(convertedNumber) {
    return <span>&#x200E;{convertedNumber}</span>
}

export function convertToHomeNumber(number) {
    let output = "";
    number = convertToEnglishNumber(number)
    if (number !== null)
        number.replace(/^\D*(\d{0,3})\D*(\d{0,4})\D*(\d{0,4})/, function (match, g1, g2, g3) {
                if (g1.length) {
                    output += g1;
                    if (g1.length === 3) {
                        if (g2.length) {
                            output += " " + g2;
                            if (g2.length === 4) {

                                if (g3.length) {
                                    output += " " + g3;
                                }
                            }
                        }
                    }
                }
            }
        );
    return output;
}

export function limitedNumber(number, limit) {
    const englishNumber = this.convertToEnglishNumber(number)
    let output = "";
    if (englishNumber !== null) {
        output = englishNumber.replace(/[^\d]/g, '')
        output = output.slice(0, limit)
    }
    return output;
}

export function replaceAllSpaceWithDash(text) {
    const regex = /\s/ig;
    if (text && text.length > 0)
        return text.toString()
            .replaceAll('( ', '(')
            .replaceAll(' )', ')')
            .replaceAll(regex, '-')
            .replaceAll(/-*-/ig, '-')
            .replaceAll('،', '')
    else
        return ''
}

export function convertToBirthDate(number) {
    let output = "";

    number = convertToEnglishNumber(number)
    if (number !== null)
        number.replace(/^\D*(\d{0,4})\D*(\d{0,2})\D*(\d{0,2})/, function (match, g1, g2, g3) {
                if (g1.length) {
                    output += g1;
                    if (g1.length === 4) {
                        if (g2.length) {
                            if ((g2.length === 2 && parseInt(g2) > 0 && parseInt(g2) <= 12) || (g2.length < 2 && g2 < 2)) {
                                output += "/" + g2;
                                if (g2.length === 2) {
                                    if (g3.length) {

                                        if ((g3.length === 2 && parseInt(g3) > 0 && parseInt(g3) <= 31) || (g3.length < 2 && g3 < 4)) {
                                            output += "/" + g3;
                                        } else if (g3.length < 2 && g3 > 3) {
                                            output += "/0" + g3
                                        } else {
                                            output += "/" + g3[0]
                                        }
                                    }
                                }
                            } else if (g2.length < 2 && g2 > 1) {
                                output += "/0" + g2
                            } else {
                                output += "/" + g2[0]
                            }
                        }
                    }
                }
            }
        );
    return output;
}

export function convertToTime(number) {
    let output = "";

    number = convertToEnglishNumber(number)
    if (number !== null)
        number.replace(/^\D*(\d{0,2})\D*(\d{0,2})/, function (match, g1, g2, g3) {
                if (g1.length) {
                    if ((g1.length === 2 && parseInt(g1) > 0 && parseInt(g1) <= 24) || (g1.length < 2 && g1 < 3)) {
                        output += g1;
                    } else if (g1.length < 2 && g1 > 1) {
                        output += "0" + g1
                    } else {
                        output += g1[0]
                    }
                    if (g1.length === 2) {
                        if (g2.length) {
                            if ((g2.length === 2 && parseInt(g2) >= 0 && parseInt(g2) <= 59) || (g2.length < 2 && g2 < 6)) {
                                output += ":" + g2;
                            } else if (g2.length < 2 && g2 > 1) {
                                output += ":0" + g2
                            } else {
                                output += ":" + g2[0]
                            }
                        }
                    }
                }
            }
        );
    return output;
}
